import './loginStyles.css'
import LoginForm from './LoginForm';


const Login = () => {
  return (
    <>
    {process.env.REACT_APP_MY_SSO === "false" &&<LoginForm/>}
    </>
  );
};

export default Login;
